export { default } from "./PaymentMethodUpdateSuccess";
